import React from 'react';
import './TypeFormatting.css';

const Decimal = ({ children }) => {
    // Ensure children is a number and convert to a float if needed
    const amount = parseFloat(children);
    
    // Create a formatter for USD currency
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2, // Ensure two decimal places
        maximumFractionDigits: 2,
    });

    // Handle invalid or non-numeric values
    if (isNaN(amount)) {
        return <span>Invalid amount</span>;
    }

    return (
        <>
            {amount < 0 ?
                <span className='negative-number'>{formatter.format(amount)}</span>
                : <span>{formatter.format(amount)}</span>
            }        
        </>

        
    );
};

export default Decimal;